import { createRandomString, decode, encode } from './random';

declare global {
  interface Window {
    /** Crypto API substitute for IE 11.x */
    msCrypto?: Crypto;
  }
}

type State = {
  /** The path that the user was initially trying to access before being redirect to login. */
  pathName: string;

  /** A unique identifier used to group the redirect flow's metadata. */
  redirectId: string;

  /** The query params that the user was initially trying to access before being redirect to login. */
  search?: string;
};

const isValidState: (state: Partial<State>) => asserts state is State = (
  state
) => {
  if (!state) {
    throw new Error('A state is required');
  }

  if (!state.pathName) {
    throw new Error('A path name is required');
  }

  if (!state.redirectId) {
    throw new Error('A redirect identifier is required');
  }
};

export const decodeState = (encodedState: string): State => {
  const state: Partial<State> = JSON.parse(decode(encodedState));

  isValidState(state);

  return state;
};

export const encodeState = (state: State): string => {
  return encode(JSON.stringify(state));
};

export const generateState = (): State => {
  const uniqueRedirectId = createRandomString(8);

  return {
    pathName: window.location.pathname,
    redirectId: uniqueRedirectId,
    search: window.location.search,
  };
};
